import request from '@/utils/request';
import { paymentServiceV1 } from '@/config/apiPrefix.config';

// 获取充值列表
export const getRechargeList = (data) => request(`${paymentServiceV1}/journal/get_journal_payment_list`, {
  params: data,
});

// 获取账单列表
export const getBillingList = (data) => request(`${paymentServiceV1}/billing/get_billing_payment_list`, {
  params: data,
});

// 更新充值订单
export const updateJournal = (data) => request(`${paymentServiceV1}/journal/update_journal`, {
  body: data,
  method: 'put',
});

// 更新账单状态
export const updateBilling = (data) => request(`${paymentServiceV1}/billing/update_billing`, {
  body: data,
  method: 'put',
});

